module.exports = __webpack_public_path__ + "img/armhole back.b8e3f909.png";